module.exports = __webpack_public_path__ + "static/jennifer.e9331021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients/jennifer.jpg
// module id = 607
// module chunks = 208176855801404